import "./ServicesContent.css";
import ServiceCard from "./ServiceCard";
import WhyChooseCard from "./WhyChooseCard";

import {
    Gamepad2,
    Globe,
    Smartphone,
    MonitorCog,
    Zap,
    Code2,
    Headphones,
    TrendingUp,
} from "lucide-react";

const ServicesContent = () => {
    return (
        <section className="services-content">

            {/* Our Services */}

            <div className="services-header">
                <span className="services-badge">OUR SERVICES</span>

                <h2>
                    What we <span>Build</span>
                </h2>

                <p>
                    We build modern digital products that help businesses grow and create
                    engaging experiences across multiple platforms.
                </p>
            </div>

            <div className="services-grid">

                <ServiceCard
                    icon={Gamepad2}
                    title="Game Development"
                    description="2D, 3D, multiplayer and cross-platform games built with Unity for mobile, PC and Web."
                    link="/services/game-development"
                />

                <ServiceCard
                    icon={Globe}
                    title="Web Development"
                    description="Modern, responsive websites, business portals and eCommerce solutions built for performance."
                    link="/services/web-development"
                />

                <ServiceCard
                    icon={Smartphone}
                    title="Mobile App Development"
                    description="Beautiful Android and iOS applications with scalable backends and intuitive user experiences."
                    link="/services/mobile-app-development"
                />

                <ServiceCard
                    icon={MonitorCog}
                    title="Software Development"
                    description="Custom business software, SaaS platforms, CRM/ERP systems and automation solutions."
                    link="/services/software-development"
                />

            </div>

            {/* Why Choose Us */}

            <div className="services-header why-header">
                <span className="services-badge">WHY US</span>

                <h2>
                    Why Choose <span>Shirdhankar Technologies</span>
                </h2>

                <p>
                    We focus on quality, innovation and long-term partnerships to deliver
                    solutions that make an impact.
                </p>
            </div>

            <div className="services-grid">

                <WhyChooseCard
                    icon={Zap}
                    title="Fast Delivery"
                    description="Rapid development cycles with clean, production-ready code delivered on time."
                />

                <WhyChooseCard
                    icon={Code2}
                    title="Modern Tech Stack"
                    description="Built using React, Node.js, Unity and the latest technologies for scalable solutions."
                />

                <WhyChooseCard
                    icon={Headphones}
                    title="Dedicated Support"
                    description="Continuous communication, updates and post-launch support whenever you need it."
                />

                <WhyChooseCard
                    icon={TrendingUp}
                    title="Scalable Solutions"
                    description="Future-ready architecture designed to grow with your business and evolving needs."
                />

            </div>

        </section>
    );
};

export default ServicesContent;